import { render, staticRenderFns } from "./RoomRenovationCompleted.vue?vue&type=template&id=1615fa36"
import script from "./RoomRenovationCompleted.vue?vue&type=script&lang=js"
export * from "./RoomRenovationCompleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports